import React, { useEffect, useState } from "react";

import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import BackspaceOutlinedIcon from "@material-ui/icons/BackspaceOutlined";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import PropTypes from "prop-types";

import Confirm from "../../Confirm";
import DefaultDataTable from "../../Shared/DefaultDataTable";
import Selector from "../../Shared/Selector";
import TabNavigationCtrlFilterPanel from "../../TabNavigationCtrlFilterPanel";

import ModalData from "./modal-data";
import ModalRemoveDock from "./modal-remove-dock";
import useStyles from "./styles";
import { getDataStorage, removeDataStorage, setDataStorage } from "../../../utils/filterManagementDataStore";

const getDataStorageBranch = () => getDataStorage('dock_config_checkSingleBranch');
const getDataStorageDockPlant = () => getDataStorage('dock_config_checkDocksPlant');

const DockTabComponent = ({
  docks,
  products,
  branches,
  loadingTypes,
  filter,
  setFilter,
  subRoutes,
  plants,
  onDeleteItem,
  onAddItem,
  onUpdateItem,
  docksError,
  clearDockErrors,
  getNotificationsFromSchedConfigAsync
}) => {
  const classes = useStyles();
  const [deletingItem, setDeletingItem] = useState(null);
  const [editingItem, setEditingItem] = useState({});
  const [isOpenAddForm, setOpenAddForm] = useState(false);
  const [docksFilter, setDocksFilter] = useState([]);
  const [dockConflict, setDockConflict] = useState(null);

  const ConfigButton = (item) => (
    <IconButton 
      data-cy={`edit-${item.id}`}
      id={`edit-${item.id}`}
      onClick={() => handleEditItem(item)}>
      <SettingsOutlinedIcon />
    </IconButton>
  );

  const handleEditItem = (item) => {
    setEditingItem(item);
    setOpenAddForm(true);
  };

  const handleAddTurn = () => {
    setEditingItem(editingItem);
    setOpenAddForm(true);
  };

  const handleModalDeleteClose = (confirm) => {
    if (confirm) {
      onDeleteItem(deletingItem);
    }
    setDeletingItem(null);
  };

  const handleSaveData = async (data) => {
    const dockData = {
      ...data,
      id_branch: filter.dockBranch ?? getDataStorageBranch()?.value,
      id_plant: filter.dockPlant ?? getDataStorageDockPlant()?.id,
    };

    if (!dockData.id) {
      return onAddItem(dockData);
    }

    return onUpdateItem(dockData);
  };

  const handleCloseModal = () => {
    setOpenAddForm(false);
    setDeletingItem(null);
    setEditingItem({});
  };

  const DeleteButton = (item) => (
    <IconButton
      data-cy={`delete-${item.id}`}
      id={`delete-${item.id}`}
      onClick={() => {
        setDeletingItem(item);
      }}
    >
      <BackspaceOutlinedIcon />
    </IconButton>
  );

  useEffect(() => {
    if (filter.loadUnload) {
      setDocksFilter(docks.filter(
        (dock) =>
          (filter.loadUnload === 1 && dock.carrega.length) ||
          (filter.loadUnload === 2 && dock.descarrega.length)
      ));
    } else {
      setDocksFilter(docks);
    }
  }, [docks, filter.loadUnload]);

  useEffect(() => {
    if (!!docksError) {
      setDockConflict(docksError);
    } else {
      setDockConflict(null);
    }
  }, [docksError, setDockConflict])

  const handleBranchFilterChange = (selectedBranch) => {
    removeDataStorage('dock_config_checkDocksPlant');
    removeDataStorage('dock_config_checkDocksPlantType');
    filter.dockPlant = null;
    filter.loadUnload = null;
    setFilter({ ...filter, dockBranch: selectedBranch && selectedBranch.value });
  };

  const handleDocksPlantFilterChange = (selectedDocksPlant) => {
    removeDataStorage('dock_config_checkDocksPlantType');
    filter.loadUnload = null;
    setFilter({
      ...filter,
      dockPlant: selectedDocksPlant ? selectedDocksPlant.value : null,
    });
  };

  const handleLoadUnloadFilterChange = (selectedLoadUnload) => {
    setFilter({
      ...filter,
      loadUnload: selectedLoadUnload ? selectedLoadUnload.value : null,
    });
  };

  const columns = [
    { name: "Nome da Doca", selector: "description", sortable: true },
    {
      name: "Planta",
      maxWidth: "200px",
      cell: (row) => (
        <div data-tag="allowRowEvents">
          {`${(plants && plants.find((p) => p.id === row.id_plant)?.name) ?? ''}`}
        </div>
      ),

      sortable: true,
    },
    {
      name: "Número BP",
      maxWidth: "200px",
      cell: (row) => (
        <div data-tag="allowRowEvents">
          {`${(plants && plants.find((p) => p.id === row.id_plant)?.bp_number) ?? ''}`}
        </div>
      ),

      sortable: true,
    },
    {
      name: "Produto que carrega",
      maxWidth: "200px",
      cell: (row) => (
        <div data-tag="allowRowEvents">{`${row.carrega.join(", ")}`}</div>
      ),
      sortable: false,
    },
    {
      name: "Produto que descarrega",
      maxWidth: "250px",
      cell: (row) => (
        <div data-tag="allowRowEvents">{`${row.descarrega.join(", ")}`}</div>
      ),
      sortable: false,
    },
    {
      name: "Capacidade por hora",
      maxWidth: "250px",
      selector: "capacity_per_hour",
      cell: (row) => (
        <div data-tag="allowRowEvents">{`${row.capacity_per_hour} caminhões`}</div>
      ),
      sortable: true,
    },
    {
      name: "Editar",
      maxWidth: "30px",
      cell: (row) => <ConfigButton {...row} />,
    },
    {
      name: "Excluir",
      maxWidth: "30px",
      cell: (row) => <DeleteButton {...row} />,
    },
  ];
  const noDataMessage = () => {
    if (!filter.dockBranch && !getDataStorageBranch()) {
      return "Por favor, selecione uma filial.";
    }
    if (!filter.dockPlant && !getDataStorageDockPlant()) {
      return "Por favor, selecione uma planta.";
    }
    return "Não existem dados a serem apresentados.";
  };

  const handleOnChange = (funcChange, valueStorage, nameStorage) => {
    funcChange(valueStorage)
    if (valueStorage !== null) {
      setDataStorage(nameStorage, valueStorage)
    } else {
      removeDataStorage(nameStorage)
    }
  }

  return (
    <>
      <TabNavigationCtrlFilterPanel
        data-cy="dock-filter"
        id="dock-filter"
        headerFilter={
          <Grid className={classes.filters}>
            <Grid className={classes.branchFilter}>
              <Selector
                options={branches}
                placeholder="Filtrar por filial"
                search={false}
                data-cy="dock-filter-branch"
                id="dock-filter-branch"
                isClearable
                selected={filter.dockBranch ?? getDataStorageBranch()?.value}
                value={getDataStorageBranch()}
                onChange={(selectedBranch) =>
                  handleOnChange(
                    handleBranchFilterChange,
                    selectedBranch,
                    'dock_config_checkSingleBranch'
                  )
                }
              />
            </Grid>
            <Grid className={classes.docksPlantFilter}>
              <Selector
                options={plants}
                placeholder="Filtrar por Planta"
                data-cy="dock-filter-plant"
                id="dock-filter-plant"
                isClearable
                selected={getDataStorageDockPlant()?.value}
                disabled={!filter.dockBranch && !plants.length && !getDataStorageBranch()}
                value={getDataStorageDockPlant()}
                onChange={(selectedDocksPlant) =>
                  handleOnChange(
                    handleDocksPlantFilterChange,
                    selectedDocksPlant,
                    'dock_config_checkDocksPlant'
                  )
                }
              />
            </Grid>
            <Grid className={classes.loadUnloadFilter}>
              <Selector
                options={loadingTypes}
                isClearable
                placeholder="Carrega / Descarrega"
                data-cy="dock-type-load"
                id="dock-type-load"
                selected={filter.loadUnload}
                disabled={!filter.dockBranch && !docks.length && !getDataStorageDockPlant()}
                value={getDataStorage('dock_config_checkDocksPlantType')}
                onChange={(selectedLoadUnload) =>
                  handleOnChange(
                    handleLoadUnloadFilterChange,
                    selectedLoadUnload,
                    'dock_config_checkDocksPlantType'
                  )
                }
              />
            </Grid>
          </Grid>
        }
        controlAreaClassName={classes.controlAreaClass}
        controlArea={
          <Button
            color="primary"
            variant="contained"
            autoFocus
            size="large"
            data-cy="dock-add"
            id="dock-add"
            disabled={(!filter.dockBranch && !getDataStorageBranch()) || (!filter.dockPlant && !getDataStorageDockPlant())}
            className={classes.addButton}
            onClick={() => handleAddTurn()}
          >
            Adicionar Doca
          </Button>
        }
        subRoutes={subRoutes}
      >
        <DefaultDataTable
          columns={columns}
          data={docksFilter}
          data-cy="dock-table"
          id="dock-table"
          noDataMessage={noDataMessage()}
        />
      </TabNavigationCtrlFilterPanel>
      <Confirm
        isOpen={!!deletingItem}
        title="Confirmar exclusão?"
        data-cy="dock-confirm-delete"
        id="dock-confirm-delete"
        message="Deseja excluir esse item da sua lista de docas?"
        okText="Sim"
        cancelText="Não"
        handleClose={handleModalDeleteClose}
      />
      <ModalData
        products={products}
        loadingTypes={loadingTypes}
        open={isOpenAddForm}
        data-cy="dock-edit-modal"
        id="dock-edit-modal"
        editedData={editingItem}
        handleClose={() => handleCloseModal()}
        handleSave={(data) => handleSaveData(data)}
      />
      <ModalRemoveDock
        data={dockConflict}
        data-cy="dock-remove-dock"
        id="dock-remove-dock"
        isOpen={!!dockConflict}
        closeReadingNotificationDialog={() => {
          setDockConflict(null);
          clearDockErrors(false);
          getNotificationsFromSchedConfigAsync();
        }}
      />
    </>
  );
};

DockTabComponent.propTypes = {
  docks: PropTypes.array.isRequired,
  products: PropTypes.array.isRequired,
  branches: PropTypes.array.isRequired,
  loadingTypes: PropTypes.array.isRequired,
  plants: PropTypes.array.isRequired,
  filter: PropTypes.object.isRequired,
  setFilter: PropTypes.func.isRequired,
  subRoutes: PropTypes.array.isRequired,
  onDeleteItem: PropTypes.func.isRequired,
  onAddItem: PropTypes.func.isRequired,
  onUpdateItem: PropTypes.func.isRequired,
  getNotificationsFromSchedConfigAsync: PropTypes.func.isRequired
};

export default DockTabComponent;
